module.exports = __webpack_public_path__ + "img/1726043779488-screenshot-1726043547853.png.ea725621.webp";